import { render, staticRenderFns } from "./HotKeysDialog.vue?vue&type=template&id=8059254a&scoped=true&"
import script from "./HotKeysDialog.vue?vue&type=script&lang=js&"
export * from "./HotKeysDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8059254a",
  null
  
)

export default component.exports